// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"7e545869","117":"bb0bc563","221":"24954a29","258":"99099e1e","269":"e19741a0","410":"dbd10e7f","488":"331979f3","495":"1f6cdb50","602":"2a28dce3","756":"c96af5d0","794":"65c6714d","870":"ef524b23"}[chunkId] + ".chunk.js";
};